// 图片相似度搜索 API 服务

export interface SimilarImageResult {
  record: {
    id: number;
    fileName: string;
    url: string;
    rawUrl?: string;
    time: string;
    size: string;
    contentType: string;
    dir?: string;
  };
  hammingDistance: number;
  similarityScore: number;
}

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  message?: string;
}

/**
 * 根据上传的图片文件搜索相似图片
 * @param file 图片文件
 * @param maxResults 最大返回结果数，默认10
 * @param maxDistance 最大汉明距离阈值，默认10
 * @returns 相似图片列表
 */
export async function searchSimilarImagesByFile(
  file: File,
  maxResults: number = 10,
  maxDistance: number = 10
): Promise<SimilarImageResult[]> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('maxResults', maxResults.toString());
  formData.append('maxDistance', maxDistance.toString());

  const response = await fetch('/img/search', {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });

  const result: ApiResponse<SimilarImageResult[]> = await response.json();
  if (result.success) {
    return result.data || [];
  }
  throw new Error(result.message || '搜索失败');
}

/**
 * 根据图片URL搜索相似图片
 * @param imageUrl 图片URL
 * @param maxResults 最大返回结果数，默认10
 * @param maxDistance 最大汉明距离阈值，默认10
 * @returns 相似图片列表
 */
export async function searchSimilarImagesByUrl(
  imageUrl: string,
  maxResults: number = 10,
  maxDistance: number = 10
): Promise<SimilarImageResult[]> {
  const formData = new FormData();
  formData.append('imageUrl', imageUrl);
  formData.append('maxResults', maxResults.toString());
  formData.append('maxDistance', maxDistance.toString());

  const response = await fetch('/img/search', {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });

  const result: ApiResponse<SimilarImageResult[]> = await response.json();
  if (result.success) {
    return result.data || [];
  }
  throw new Error(result.message || '搜索失败');
}
